module.exports = __webpack_public_path__ + "img/bg_files.1bc75311.png";